export default __webpack_public_path__ + "static/operators@2x-5af2ce61515a938c52b199c3884e8859.png";